export default __webpack_public_path__ + "static/media/tick-new.215e4fc3.svg";